import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import AllEmployeeAddPopup from "../../../../components/modelpopup/AllEmployeeAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeListFilter from "./../components/EmployeeListFilter";
import { Table, Pagination, Tooltip , Badge} from "antd";
import Image from "components/Image";
import { RightOutlined } from "@ant-design/icons";
import {  toast, Bounce } from 'react-toastify';
import { isEventUpcoming } from "utils/common";


import {
  itemRender,
  pageSizeOptions,
  CustomRow
} from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";
import FilterDrawer from "components/Drawer/filterDrawer";
import { useEmployee } from "./../context/employeeContext";
import { formatDateHandler2 } from "utils/common";
import { Button } from "components/Button";
import { TbMailShare } from "react-icons/tb";
import { resendInvitation } from "api/services/employee";


const AllEmployee = () => {
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleEmployeeDetailPage,
    handleDateChange,
    appliedFilterCount,
    handleExport,
    exportLoading
  } = useEmployee();
  const navigate = useNavigate();
  const [invitationLoader, setInvitationLoader] = useState(false)



  const  handleResend = (employee) =>{
    console.log(employee, "KKK")
    setInvitationLoader(true)
      resendInvitation({company_user : employee?.id}).then(res=>{
        toast.success('Invitation mail send successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setInvitationLoader(false)
        }).catch(err=>{
          toast.error('Failed to send invitation mail', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
            setInvitationLoader(false)
        })
  }

  const iconGenerator = (data) =>{
    if(data === "completed" || data === true){
      return "fa fa-check-circle"
    }
    else if(data === "partial"){
      return "fa fa-exclamation-circle"
    }
    else if(data === "empty" || data === false){
      return "fa fa-times-circle"
    }
    return "fa fa-check-circle"
  }
  const statusGenerator = (data) =>{
    if(data === "empty" || data === false){
      return "danger"
    }
    if(data === "partial"){
      return "warning"
    }
    if(data === "completed" || data === true){
      return "success"
    }
    return "primary"
  }
  const columns = [
    // {
    //   title: "Employee id",
    //   dataIndex: "id",
    //   sorter: true,
    //   // render: (text, record) => (
    //   //   <span className="table-avatar">
    //   //     <Link to="/profile" className="avatar">
    //   //       <img alt="" src={record.image} />
    //   //     </Link>
    //   //     <Link to="/profile">
    //   //       {text} <span>{record.role}</span>
    //   //     </Link>
    //   //   </span>
    //   // ),
    //   // sorter: (a, b) => a.name.length - b.name.length,
    // },
    {
      title: "Image",
      dataIndex: "profile_image",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)} className="avatar">
            <Image  src={record?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
          </a>
        </span>
      ),
      // sorter: (a, b) => a.emp_no.length - b.emp_no.length,
    },
    {
      title: "Emp No",
      dataIndex: "emp_no",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)}>{text}</a>
        </span>
      ),
      // sorter: (a, b) => a.employee_id.length - b.employee_id.length,
    },
  
    {
      title: "First Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)}>{text}</a>
        </span>
      ),
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    // {
    //   title: "Middle Name",
    //   dataIndex: "middle_name",
    //   sorter: true,
    //   render: (text, record, index) => (
    //     <span className="table-avatar">          
    //       <a onClick={()=>handleEmployeeDetailPage(record.id, index)}>{text}</a>
    //     </span>
    //   ),
    //   // sorter: (a, b) => a.email.length - b.email.length,
    // },
  
  
    {
      title: "Last Name",
      dataIndex: "last_name",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)}>{text}</a>
        </span>
      ),
      // sorter: (a, b) => a.mobile.length - b.mobile.length,
    },
    {
      title: "Phone",
      dataIndex: "usercontact_company_user__mobile_no",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <Link
                to={`tel:${record?.contact?.mobile_no}`}
              >
                {record?.contact?.mobile_no}
              </Link>
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Email",
      dataIndex: "usercontact_company_user__private_email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <Link to={`/employees/${record.id}`}>{record?.contact?.private_email}</Link>
          {
            !record.joined &&
            <Button
            label="Resend Invitation"
              className="btn btn-primary text-xs ms-2 btn-sm"
              icon={"fa fa-envelope fa-sm text-sm me-1"}
              loading={invitationLoader}
              disabled={invitationLoader}
              onClick={()=>handleResend(record)}
            />
          }
           
              
       
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Designation",
      dataIndex: "user_employment_company_user__position__name",
      render: (data, record) => (
        <div>
        
            <div className="dropdown">
              <span className="badge badge-soft-info">{record?.employment?.position?.name}</span>
  
            
            </div>
        
        </div>
      ),
      sorter: true,
    },
    {
      title: "Department ",
      dataIndex: "user_employment_company_user__department__name",
      sorter: true,
      render: (data, record) => (
        <div>
          {record?.employment?.department && (
            <div className="dropdown">
              <span class="badge text-bg-secondary">
                {record?.employment?.department?.name}
              </span>
  
        
            </div>
          )}
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Cost Center ",
      dataIndex: "cost_center",
      sorter: true,
      align: "center",
      render: (data, record) => (
        <div>
          {record?.cost_center?.code && (
              <span class="">
                {record?.cost_center?.code}
              </span>
  
          )}
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Employment Date",
      dataIndex: "user_employment_company_user__employment_date",
      sorter: true,
      render: (text, record) => <>{formatDateHandler2(record?.employment?.employment_date)}</>,
  
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Profile Completion Status",
      dataIndex: "profile_completion_status",
      // sorter: true,
      render: (text, record) => <>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.profile_image)}`}>Profile Image <i className={`  ${iconGenerator(record?.profile_completeness?.profile_image)} text-${statusGenerator(record?.profile_completeness?.profile_image)}`}/></span>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.emergency_contact)}`}>Emergency Contact <i className={`  ${iconGenerator(record?.profile_completeness?.emergency_contact)} text-${statusGenerator(record?.profile_completeness?.emergency_contact)}`}/></span>

      <br/>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.emirates_id)}`}>Emirates ID <i className={`  ${iconGenerator(record?.profile_completeness?.documents?.emirates_id)} text-${statusGenerator(record?.profile_completeness?.documents?.emirates_id)}`}/></span>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.passport)}`}>Passport <i className={`  ${iconGenerator(record?.profile_completeness?.documents?.passport)} text-${statusGenerator(record?.profile_completeness?.documents?.passport)}`}/></span>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.visa)}`}>Visa <i className={`  ${iconGenerator(record?.profile_completeness?.documents?.visa)} text-${statusGenerator(record?.profile_completeness?.documents?.visa)}`}/></span>
      <br/>
      <span className={`me-1 badge badge-soft-${statusGenerator(record?.profile_completeness?.personal_info)}`}>Personal Info <i className={`  ${iconGenerator(record?.profile_completeness?.personal_info)} text-${statusGenerator(record?.profile_completeness?.personal_info)}`}/></span>

      </>,
    },
    // {
    //   title: "Search Name",
    //   dataIndex: "search_name",
    //   sorter: true,
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    // {
    //   title: "Balance",
    //   dataIndex: "balance",
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    // {
    //   title: "Comment",
    //   dataIndex: "comment",
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {employeeData.map((employee, index) => (
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-xl-4 "
              key={employee.id}
            >
               {
                employee?.is_celeb_birthday &&
                <Badge.Ribbon 
            text={ "Birthday 🎉"} 
            color={"green"}
            placement={"start"}
            size={"small"}
            style={{ zIndex: 1 , position: 'absolute', top: 5, left: -8 }}
            >
              <span></span>
              </Badge.Ribbon>
              }
              {

               isEventUpcoming( employee?.employment?.employment_date) &&
               <Badge.Ribbon 
            text={ "Anniversary 🎉"} 
            color={"yellow"}
            placement={"start"}
            size={"small"}
            style={{ zIndex: 1 , position: 'absolute', top: employee?.is_celeb_birthday ? 30 : 5, left: -8 }}
            >
              <span></span>
            </Badge.Ribbon>
              }
              <div className="profile-widget d-flex flex-column justify-content-center" style={{minHeight:180}}>
               
                {/* <div className="dropdown profile-action">
                  <Link
                    to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons">more_vert</i>
                  </Link>
                 
                  <div className="dropdown-menu dropdown-menu-right">
                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_employee"
                    >
                      <i className="fa fa-pencil m-r-5" /> Edit
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#delete"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link>
                  </div>
                </div> */}
                <div className="row" >
                  <div className="col-4 d-flex justify-content-center align-items-center" >
                  <div className="profile-img">
                    <a onClick={()=>handleEmployeeDetailPage(employee.id, index)} className="avatar">
                   
                      <Image  src={employee?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                    </a>
                  </div>
                  
                  </div>
                 
                  <div  className="col-8" >
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a 
                  // to={`/profile/${employee.id}`}
                  onClick={()=>handleEmployeeDetailPage(employee.id, index)}
                  >
                    {employee.first_name} {employee?.last_name}
                  </a>
                </h4>
                <div className="small text-muted text-start" >Emp No : {employee.emp_no}</div>
                <div className="small text-muted text-start">{employee.email}</div>
                <div className="small text-muted text-start">{employee.company_phone_number}</div>
                <div className="small text-muted text-start">{employee?.employment?.position?.name}</div>
                <div className="small text-muted text-start">Cost Center : {employee.cost_center?.code}</div>

                {
                !employee.joined &&
                <div className="small text-muted text-start">
                <Button
                label="Resend Invitation"
                  className="btn btn-primary text-xs btn-sm"
                  icon={"fa fa-envelope fa-sm text-sm me-1"}
                  loading={invitationLoader}
                  disabled={invitationLoader}
                  onClick={()=>handleResend(employee)}
                />
                </div>
              }
           

                  </div>
                  
                    </div>
                

              </div>
            </div>
          ))}
        </>
      );
    }
  };

  
// // Custom row component
// const CustomRow = (props) => {
//   const { children, ...restProps } = props;
//   const anniversaryStatus = isEventUpcoming(props?.record?.employment?.employment_date);

//   return (
//     <>
   
//     {
//       props?.record?.is_celeb_birthday &&
//       <Badge.Ribbon 
//     text={ "Birthday 🎉"} 
//     color={"green"}
//     placement={"start"}
//     style={{ zIndex: 1 , position: 'absolute', top: 0, left: -10 }}
//   >
//     <span></span>
//   </Badge.Ribbon>
//     }
//     {
//       anniversaryStatus  &&
//       <Badge.Ribbon 
//     text={ "Anniversary 🎉"} 
//     color={"yellow"}
//     placement={"start"}
//     style={{ zIndex: 1 , position: 'absolute', top: props?.record?.is_celeb_birthday ? 25 : 0, left: -10 }}
//   >
//     <span></span>
//   </Badge.Ribbon>
//      }
    
//   <tr
//   {...restProps}
//   style={{
//     backgroundColor: '#f6f6f6',
//     cursor: 'pointer',
//   }}
//   onClick={() => console.log('Row clicked:', props['data-row-key'])}
// >
//   {children}
// </tr>
// </>
//   );
// };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee"
            title="Dashboard"
            subtitle="Employee"
            modal="#add_employee"
            name="Add Employee"
            // Linkname="/employees"
            // Linkname1="/employees-list"
            view={view}
            setView={setView}
            showModal={false}
          />
          <EmployeeListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search employee"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            appliedFilterCount={appliedFilterCount}
            handleExport={handleExport}
            exportLoading={exportLoading}
             />

          {view == "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={employeeData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  components={{
                    body: {
                      row: CustomRow, // override row component
                    },
                  }}
                  onRow={(record, index) => ({
                    record, // 👈 injects record into the custom row
                    index,
                  })}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <AllEmployeeAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Employee" />

      <FilterDrawer


        searchPlaceholder={"Search employee"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}

        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      />
      {/* Delete Modal */}
    </div>
  );
};

export default AllEmployee;
